/**
 * mc-related.js — Manifesto (task 0027)
 *
 * Interatividade da section related-products-manifesto:
 *
 *   1. Reveal dos shells — o header (eyebrow/heading/contexto/setas) e o CTA
 *      vivem FORA do conteúdo injetado (DP-3: o render do endpoint de
 *      recomendações não tem o objeto `product`), em shells `hidden`.
 *      ⚠️ DP-3b (hotfix): o <product-recommendations> fica FORA dos shells —
 *      dentro de wrapper hidden ele perde geometria e o IntersectionObserver
 *      do global.js nunca dispara o fetch (deadlock). Aqui só observamos a
 *      injeção do grid e revelamos os shells + classe `is-live` na raiz.
 *      API vazia => nada injeta => shells nunca revelam (estado vazio ok).
 *   2. Setas do rail — delegação de evento no `document` (mesmo padrão do
 *      mc-quick-add.js), então funcionam sobre conteúdo injetado via fetch.
 *      Scroll suave gated a prefers-reduced-motion; setas somem sem overflow.
 *
 * O fetch/injeção em si é do <product-recommendations> (global.js) — intocado.
 */

(function () {
  'use strict';

  var GAP = 20;

  function updateNav(root) {
    var nav = root.querySelector('[data-mc-rail-nav]');
    var rail = root.querySelector('[data-mc-rail]');
    if (!nav || !rail) return;
    var hasOverflow = rail.scrollWidth > rail.clientWidth + 4;
    nav.classList.toggle('is-hidden', !hasOverflow);
  }

  function initRoot(root) {
    var rec = root.querySelector('product-recommendations');
    if (!rec) return;

    function tryReveal() {
      if (!rec.querySelector('[data-mc-rail]')) return false;
      root.classList.add('is-live');
      var head = root.querySelector('[data-mc-related-head]');
      var cta = root.querySelector('[data-mc-related-cta]');
      if (head) head.hidden = false;
      if (cta) cta.hidden = false;
      updateNav(root);
      return true;
    }

    if (tryReveal()) return;

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (tryReveal()) mo.disconnect();
      });
      mo.observe(rec, { childList: true, subtree: true });
    } else {
      // Fallback improvável: revela sem esperar (grid chega logo depois).
      root.classList.add('is-live');
      root.querySelectorAll('[data-mc-related-head], [data-mc-related-cta]').forEach(function (el) {
        el.hidden = false;
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-mc-related]');
    if (!roots.length) return;
    roots.forEach(initRoot);

    window.addEventListener('resize', function () {
      roots.forEach(function (root) {
        if (root.classList.contains('is-live')) updateNav(root);
      });
    });
  }

  // Setas do rail — delegado no document (funciona pós-injeção).
  document.addEventListener('click', function (ev) {
    var prev = ev.target.closest('[data-mc-rail-prev]');
    var next = ev.target.closest('[data-mc-rail-next]');
    if (!prev && !next) return;

    var root = (prev || next).closest('[data-mc-related]');
    var rail = root && root.querySelector('[data-mc-rail]');
    if (!rail) return;

    var item = rail.querySelector('.mc-related__item');
    var step = item ? (item.offsetWidth + GAP) * 2 : Math.round(rail.clientWidth * 0.8);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({ left: prev ? -step : step, behavior: reduce ? 'auto' : 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
